<template>
  <div id="about" class="d-flex justify-content-center">
    <div class="padding">
      <div class="row">
        <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
          <img class="img-fluid" src="../assets/about.jpg" alt />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="row">
            <div class="col-12">
              <h2 class="my-3" style="color: #ba2428;">About</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-dark">
              <p>
                As part of the Africa Union's agenda to speed up AfCFTA uptake following the formal launch of the start of trading in January 2021, the "AfCFTA Number" Portal i s proposed as a “public digital good” to ensure that the “net of AfCFTA benefits” does not miss any African enterprise or organisation, however small, weak or remote.
              </p>
              <p>
                Through the concept of a unique, continentally recognised, entity identifier, SMEs, sole proprietors, register and obtain a “portable digital identity” as the basis of a pan-African business profile and trust-accreting mechanism. The AfCFTA number shall be the fulcrum around which AfCFTA Link’s interoperable engine shall run to ensure seamless flow of process data across multiple elements of an emerging, unified, trade infrastructure astride the African continent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

.about ul {
	list-style-type: circle red;
}
p{
  line-height: 2em;
}
</style>